import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-public',
  templateUrl: './base-public.component.html',
  styles: []
})
export class BasePublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/base-public/base-public.component.ts